export default __webpack_public_path__ + "static/rbpp-d553b0c9e492494c25111ce564a935f2.mp4";